"use strict";

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockFeeMultiplierDto = void 0;

var GeneratorUtils_1 = require("./GeneratorUtils");

var BlockFeeMultiplierDto = /*#__PURE__*/function () {
  function BlockFeeMultiplierDto(blockFeeMultiplier) {
    _classCallCheck(this, BlockFeeMultiplierDto);

    this.blockFeeMultiplier = blockFeeMultiplier;
  }

  _createClass(BlockFeeMultiplierDto, [{
    key: "getBlockFeeMultiplier",
    value: function getBlockFeeMultiplier() {
      return this.blockFeeMultiplier;
    }
  }, {
    key: "getSize",
    value: function getSize() {
      return 4;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return GeneratorUtils_1.GeneratorUtils.uint32ToBuffer(this.getBlockFeeMultiplier());
    }
  }], [{
    key: "loadFromBinary",
    value: function loadFromBinary(payload) {
      var blockFeeMultiplier = GeneratorUtils_1.GeneratorUtils.bufferToUint32(Uint8Array.from(payload));
      return new BlockFeeMultiplierDto(blockFeeMultiplier);
    }
  }]);

  return BlockFeeMultiplierDto;
}();

exports.BlockFeeMultiplierDto = BlockFeeMultiplierDto;